import { useState } from "react";
import AuthLayout from "../components/AuthLayout";
import { supabase } from "../services/supabase";
import { validateEmail } from "../utils/validators";

export default function ForgotPassword({ onBack, onEmailSent }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    // ✅ VALIDATION
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }

    setError("");
    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/login`,
      });

      if (error) throw error;
      onEmailSent(email);
    } catch (err) {
      setError(
        err.message || "Failed to send reset email. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              Forgot your password?
            </h1>
            <p className="text-gray-500">
              Enter your email to receive a password reset link
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="e.g. username@giveaura.com"
                className={`w-full px-4 py-3 rounded-full border 
                  ${error ? "border-red-500" : "border-gray-300"}
                  focus:outline-none focus:ring-2 focus:ring-[#06402B]`}
              />

              {error && (
                <p className="text-red-500 text-xs mt-2">{error}</p>
              )}
            </div>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="w-full bg-[#06402B] text-white py-3 rounded-full font-medium hover:bg-green-900 transition-colors disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send Email"}
            </button>

            <button
              type="button"
              onClick={onBack}
              className="w-full flex items-center justify-center gap-2 text-gray-700 py-2 hover:underline"
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </main>
    </AuthLayout>
  );
}
